import axios from "axios";


export default class LexiconPopup
{
    constructor ()
    {

        this.isReady = false;

        this.allLexiconWords      = document.querySelectorAll( 'abbr[data-lexique-id], abbr[data-lexicon-id]' );
        this.allLexiconWordsArray = Array.from( this.allLexiconWords );

        // console.log("   this.allLexiconWords ",    this.allLexiconWords )

        // I have no words
        // I am ... speechless
        if ( this.allLexiconWords.length < 1 )
        {
            return;
        }


        axios.defaults.headers.common = {
            'X-Requested-With' : 'XMLHttpRequest',
            'X-CSRF-TOKEN'     : document.querySelector( 'meta[name="csrf-token"]' ).getAttribute( 'content' ),
        };

        this.injectModal();

        this.compileNeededWords();
        this.bindEvents();
    }


    bindEvents ()
    {
        this.allLexiconWordsArray.forEach( el => el.addEventListener( 'click', this.prepWordModal.bind( this ) ) );
    }

    bindCloseEvents ()
    {
        document.addEventListener( 'click', this.handleCloseClick.bind( this ) );
    }

    unbindCloseEvents ()
    {
        document.removeEventListener( 'click', this.handleCloseClick );
    }

    handleCloseClick ( event )
    {
        if ( event.target.classList.contains( 'bg' ) || event.target.classList.contains( 'btn-close' ) )
        {
            this.hideModal();
        }
    }

    async compileNeededWords ()
    {
        let ids = [];

        this.allLexiconWordsArray.forEach( el =>
        {

            const dataId = parseInt( el.dataset.lexiconId ?? el.dataset.lexiqueId ?? false);

            if ( dataId )
            {
                ids.push( dataId );
            }

        } );

        if ( ids.length > 0 )
        {

            try
            {
                const queryString = new URLSearchParams( { ids : ids } ).toString();
                let response      = await axios.get( `/endpoints/lexique?${queryString}` );

                this.lexiconDict = response.data ?? [];
                this.isReady     = true;
            }
            catch (error)
            {
                console.error( '[LexiconPopUp] Error while retrieving words info', error );
            }

        }
    }


    prepWordModal ( event )
    {

        if ( !this.isReady )
        {

            return;
        }

        const abbr      = event.currentTarget;
        const lexiconId = abbr.dataset.lexiconId ??  abbr.dataset.lexiqueId ?? false;


        let wantedWord = false;

        for ( const lexiconIdElement of this.lexiconDict )
        {

            if ( parseInt( lexiconIdElement.id ) === parseInt( lexiconId ) )
            {
                wantedWord = lexiconIdElement;
                break;
            }
        }


        if ( !wantedWord )
        {
            console.error( '[LexiconPopUp] Was looking for word ID #' + lexiconId + ' but could not find it.' );
            return;
        }

        const formattedWord = this.modalInnerTemplate( wantedWord );


        const innerModal = this.modal.querySelector( '.modal-inner-inner' );

        innerModal.innerHTML = formattedWord;

        this.showModal();
    }

    showModal ()
    {
        if (!this.modal)
            return;

        this.modal.style.display = 'block';
        this.bindCloseEvents();
    }

    hideModal ()
    {
        if (!this.modal)
            return;

        this.modal.style.display = 'none';
        this.unbindCloseEvents();
    }

    modalInnerTemplate ( word )
    {

        return '<h3 class="word">' + word.title + '</h3>' +
            // '<h4 class="type">' + word.type + '</h4>' +
            '<div class="word-description">' + (word?.content?.fr ?? '') + '</div>' +
            '<div class="lexicon-link-container"><a class="link-show-all" href="' + word.url + '">Lexique</a></div>';
    }

    injectModal ()
    {

        const footer    = document.getElementById( "footer" );

        if (!footer)
        {
            return;
        }

        const modalHtml = '' +
            '<div id="lexicon-modal" class="modal-container">' +
            '       <div class="bg">' +
            '            <div class="modal">' +
            '                <div class="modal-inner">' +
            '                        <div class="inner-bg" role="presentation"></div>' +
            '                        <div class="kids-bg" role="presentation"><div class="frame"></div></div>' +
            '                        <button type="button" class="btn btn-close btn-close-modal">' +
            '                           <span class="sr-only">Fermer</span>' +
            '                        </button>' +
            '                        <div class="modal-inner-inner">' +
            '                        </div>' +
            '               </div>' +
            '           </div>' +
            '       </div>' +
            '</div>';
        footer.insertAdjacentHTML( 'afterend', modalHtml )


        this.modal = document.querySelector( '#lexicon-modal' );

    }
}

